import { render, staticRenderFns } from "./SearchSummary.vue?vue&type=template&id=fb07efb8&"
import script from "./SearchSummary.vue?vue&type=script&lang=ts&"
export * from "./SearchSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports